(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["comparativachapa"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initRoot(root) {
    if (!root || root.dataset.tpcReady === 'true') return;

    root.dataset.tpcReady = 'true';

    var targets = root.querySelectorAll(
      '[data-tpc-card], [data-tpc-row], [data-tpc-reveal]'
    );

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;

            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          });
        },
        {
          threshold: 0.12,
          rootMargin: '0px 0px -6% 0px'
        }
      );

      targets.forEach(function (target) {
        observer.observe(target);
      });
    } else {
      targets.forEach(function (target) {
        target.classList.add('is-visible');
      });
    }
  }

  function initAll() {
    document
      .querySelectorAll('[data-tranqui-pro-compare]')
      .forEach(initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector(
      '[data-tranqui-pro-compare]'
    );

    if (root) {
      initRoot(root);
    }
  });

  document.addEventListener('shopify:block:select', function (event) {
    var row = event.target.matches('[data-tpc-row]')
      ? event.target
      : event.target.querySelector('[data-tpc-row]');

    if (!row) return;

    row.classList.add('is-visible');

    row.scrollIntoView({
      behavior: 'smooth',
      block: 'center'
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mayorista"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tranqui-wholesale')) {
    customElements.define('tranqui-wholesale', class extends HTMLElement {
      connectedCallback() {
        if (this.twmController) this.twmController.abort();
        if (this.twmResizeObserver) this.twmResizeObserver.disconnect();
        this.twmController = new AbortController();
        const signal = this.twmController.signal;
        this.querySelectorAll('a[data-twm-link]').forEach((link) => {
          try {
            const url = new URL(link.dataset.twmLink.trim());
            const allowedHosts = ['wa.me', 'api.whatsapp.com', 'web.whatsapp.com', 'www.whatsapp.com', 'whatsapp.com'];
            if (url.protocol !== 'https:' || !allowedHosts.includes(url.hostname)) return;
            url.hash = '';
            url.searchParams.set('text', link.dataset.twmMessage || '');
            link.href = url.toString();
          } catch (_) {
            /* Conserva el enlace configurado si no se puede interpretar. */
          }
        });
        const track = this.querySelector('.twm__grid');
        const nav = this.querySelector('.twm__slider-nav');
        if (!track || !nav) return;
        const previous = nav.querySelector('[data-twm-direction="-1"]');
        const next = nav.querySelector('[data-twm-direction="1"]');
        const mobile = window.matchMedia('(max-width: 649px)');
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        const maxScroll = () => Math.max(0, track.scrollWidth - track.clientWidth);
        const update = () => {
          const enabled = mobile.matches && maxScroll() > 2;
          nav.hidden = !enabled;
          if (enabled) {
            track.tabIndex = 0;
            track.setAttribute('aria-roledescription', 'carrusel');
          } else {
            track.removeAttribute('tabindex');
            track.removeAttribute('aria-roledescription');
          }
          previous.disabled = !enabled || track.scrollLeft <= 2;
          next.disabled = !enabled || track.scrollLeft >= maxScroll() - 2;
        };
        const scrollToPosition = (left) => {
          track.scrollTo({
            left: Math.max(0, Math.min(maxScroll(), left)),
            behavior: reducedMotion.matches ? 'instant' : 'smooth'
          });
        };
        const move = (direction) => {
          if (!mobile.matches) return;
          const card = track.querySelector('.twm__card');
          if (!card) return;
          const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
          scrollToPosition(track.scrollLeft + direction * (card.getBoundingClientRect().width + gap));
        };
        previous.addEventListener('click', () => move(-1), { signal });
        next.addEventListener('click', () => move(1), { signal });
        track.addEventListener('scroll', update, { passive: true, signal });
        track.addEventListener('keydown', (event) => {
          if (event.target !== track || !mobile.matches) return;
          if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          if (event.key === 'Home') scrollToPosition(0);
          else if (event.key === 'End') scrollToPosition(maxScroll());
          else move(event.key === 'ArrowRight' ? 1 : -1);
        }, { signal });
        this.addEventListener('shopify:block:select', (event) => {
          if (!mobile.matches || !(event.target instanceof Element)) return;
          const card = event.target.closest('.twm__card');
          if (!card || !track.contains(card)) return;
          scrollToPosition(track.scrollLeft + card.getBoundingClientRect().left - track.getBoundingClientRect().left);
        }, { signal });
        window.addEventListener('resize', update, { passive: true, signal });
        if ('ResizeObserver' in window) {
          this.twmResizeObserver = new ResizeObserver(update);
          this.twmResizeObserver.observe(track);
        }
        update();
      }
      disconnectedCallback() {
        if (this.twmController) this.twmController.abort();
        if (this.twmResizeObserver) this.twmResizeObserver.disconnect();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["paseocomp"] && !Shopify.designMode) return;
  try {
    

(function () {

  var roots =
    document.querySelectorAll(
      '[data-tranqui-kit-flow]'
    );


  roots.forEach(function (root) {

    if (
      root.dataset.tranquiKitFlowReady
      === 'true'
    ) return;


    root.dataset.tranquiKitFlowReady =
      'true';


    var timeline =
      root.querySelector(
        '[data-tk-timeline]'
      );


    if (!timeline) return;


    var steps =
      Array.from(
        root.querySelectorAll(
          '[data-tk-step]'
        )
      );


    var reveals =
      Array.from(
        root.querySelectorAll(
          '[data-tk-reveal]'
        )
      );


    var observer =
      null;


    var ticking =
      false;



    function clamp(
      value,
      min,
      max
    ) {

      return Math.min(
        Math.max(
          value,
          min
        ),
        max
      );

    }



    function showAll() {

      steps
        .concat(reveals)
        .forEach(
          function (item) {

            item.classList.add(
              'is-visible'
            );

          }
        );

    }



    if (
      'IntersectionObserver'
      in window
    ) {

      observer =
        new IntersectionObserver(

          function (entries) {

            entries.forEach(
              function (entry) {

                if (
                  !entry.isIntersecting
                ) return;


                entry.target
                  .classList
                  .add(
                    'is-visible'
                  );


                observer.unobserve(
                  entry.target
                );

              }
            );

          },

          {
            threshold:
              0.16,

            rootMargin:
              '0px 0px -8% 0px'
          }

        );


      steps.forEach(
        function (step) {

          observer.observe(
            step
          );

        }
      );


      reveals.forEach(
        function (item) {

          observer.observe(
            item
          );

        }
      );

    } else {

      showAll();

    }



    function updateProgress() {

      ticking =
        false;


      var rect =
        timeline.getBoundingClientRect();


      var viewportHeight =
        window.innerHeight ||
        document.documentElement
          .clientHeight;


      var start =
        viewportHeight * 0.76;


      var end =
        viewportHeight * 0.28;


      var distance =
        rect.height +
        start -
        end;


      var travelled =
        start -
        rect.top;


      var progress =
        clamp(

          travelled /
          Math.max(
            distance,
            1
          ),

          0,

          1

        );


      root.style.setProperty(
        '--tk-progress',
        progress.toFixed(4)
      );

    }



    function requestUpdate() {

      if (ticking) return;


      ticking =
        true;


      window.requestAnimationFrame(
        updateProgress
      );

    }



    window.addEventListener(
      'scroll',
      requestUpdate,
      {
        passive:
          true
      }
    );


    window.addEventListener(
      'resize',
      requestUpdate,
      {
        passive:
          true
      }
    );


    updateProgress();

  });



  document.addEventListener(
    'click',

    function (event) {

      var btn =
        event.target.closest &&
        event.target.closest(
          '[data-tk-add-to-cart]'
        );


      if (!btn) return;

      if (btn.disabled) return;

      if (
        btn.classList.contains(
          'is-loading'
        )
      ) return;


      var variantId =
        btn.getAttribute(
          'data-variant-id'
        );


      if (!variantId) return;


      var labelEl =
        btn.querySelector(
          '.tranqui-kit-flow__addon-btn-label'
        );


      var addLabel =
        btn.getAttribute(
          'data-add-label'
        ) || 'Agregar al carrito';

      var addedLabel =
        btn.getAttribute(
          'data-added-label'
        ) || 'Agregado ✓';

      var errorLabel =
        'No se pudo agregar';


      btn.classList.add(
        'is-loading'
      );

      btn.classList.remove(
        'is-added',
        'is-error'
      );


      fetch('/cart/add.js', {

        method: 'POST',

        headers: {
          'Content-Type':
            'application/json',

          Accept:
            'application/json'
        },

        body: JSON.stringify({

          items: [
            {
              id:
                parseInt(
                  variantId,
                  10
                ),

              quantity: 1
            }
          ]

        })

      })

        .then(function (response) {

          if (!response.ok) {

            return response
              .json()
              .then(
                function (data) {

                  throw new Error(
                    data.description ||
                    'cart-error'
                  );

                }
              );

          }


          return response.json();

        })

        .then(function () {

          btn.classList.remove(
            'is-loading'
          );

          btn.classList.add(
            'is-added'
          );


          if (labelEl) {

            labelEl.textContent =
              addedLabel;

          }


          document.dispatchEvent(
            new CustomEvent(
              'tranqui:cart:updated'
            )
          );


          window.setTimeout(
            function () {

              btn.classList.remove(
                'is-added'
              );


              if (labelEl) {

                labelEl.textContent =
                  addLabel;

              }

            },

            2200

          );

        })

        .catch(function () {

          btn.classList.remove(
            'is-loading'
          );

          btn.classList.add(
            'is-error'
          );


          if (labelEl) {

            labelEl.textContent =
              errorLabel;

          }


          window.setTimeout(
            function () {

              btn.classList.remove(
                'is-error'
              );


              if (labelEl) {

                labelEl.textContent =
                  addLabel;

              }

            },

            2200

          );

        });

    }

  );



  document.addEventListener(
    'shopify:block:select',

    function (event) {

      var step =

        event.target.matches &&
        event.target.matches(
          '[data-tk-step]'
        )

          ? event.target

          : (
              event.target.querySelector

                ? event.target
                    .querySelector(
                      '[data-tk-step]'
                    )

                : null
            );


      if (!step) return;


      step.classList.add(
        'is-visible'
      );


      step.scrollIntoView({
        behavior:
          'smooth',

        block:
          'center'
      });

    }

  );

})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pasoskit"] && !Shopify.designMode) return;
  try {
    

(function () {

  var roots =
    document.querySelectorAll(
      '[data-tranqui-kit-flow]'
    );


  roots.forEach(function (root) {

    if (
      root.dataset.tranquiKitFlowReady
      === 'true'
    ) return;


    root.dataset.tranquiKitFlowReady =
      'true';


    var timeline =
      root.querySelector(
        '[data-tk-timeline]'
      );


    if (!timeline) return;


    var steps =
      Array.from(
        root.querySelectorAll(
          '[data-tk-step]'
        )
      );


    var reveals =
      Array.from(
        root.querySelectorAll(
          '[data-tk-reveal]'
        )
      );


    var observer =
      null;


    var ticking =
      false;



    function clamp(
      value,
      min,
      max
    ) {

      return Math.min(
        Math.max(
          value,
          min
        ),
        max
      );

    }



    function showAll() {

      steps
        .concat(reveals)
        .forEach(
          function (item) {

            item.classList.add(
              'is-visible'
            );

          }
        );

    }



    if (
      'IntersectionObserver'
      in window
    ) {

      observer =
        new IntersectionObserver(

          function (entries) {

            entries.forEach(
              function (entry) {

                if (
                  !entry.isIntersecting
                ) return;


                entry.target
                  .classList
                  .add(
                    'is-visible'
                  );


                observer.unobserve(
                  entry.target
                );

              }
            );

          },

          {
            threshold:
              0.16,

            rootMargin:
              '0px 0px -8% 0px'
          }

        );


      steps.forEach(
        function (step) {

          observer.observe(
            step
          );

        }
      );


      reveals.forEach(
        function (item) {

          observer.observe(
            item
          );

        }
      );

    } else {

      showAll();

    }



    function updateProgress() {

      ticking =
        false;


      var rect =
        timeline.getBoundingClientRect();


      var viewportHeight =
        window.innerHeight ||
        document.documentElement
          .clientHeight;


      var start =
        viewportHeight * 0.76;


      var end =
        viewportHeight * 0.28;


      var distance =
        rect.height +
        start -
        end;


      var travelled =
        start -
        rect.top;


      var progress =
        clamp(

          travelled /
          Math.max(
            distance,
            1
          ),

          0,

          1

        );


      root.style.setProperty(
        '--tk-progress',
        progress.toFixed(4)
      );

    }



    function requestUpdate() {

      if (ticking) return;


      ticking =
        true;


      window.requestAnimationFrame(
        updateProgress
      );

    }



    window.addEventListener(
      'scroll',
      requestUpdate,
      {
        passive:
          true
      }
    );


    window.addEventListener(
      'resize',
      requestUpdate,
      {
        passive:
          true
      }
    );


    updateProgress();

  });



  document.addEventListener(
    'click',

    function (event) {

      var btn =
        event.target.closest &&
        event.target.closest(
          '[data-tk-add-to-cart]'
        );


      if (!btn) return;

      if (btn.disabled) return;

      if (
        btn.classList.contains(
          'is-loading'
        )
      ) return;


      var variantId =
        btn.getAttribute(
          'data-variant-id'
        );


      if (!variantId) return;


      var labelEl =
        btn.querySelector(
          '.tranqui-kit-flow__addon-btn-label'
        );


      var addLabel =
        btn.getAttribute(
          'data-add-label'
        ) || 'Agregar al carrito';

      var addedLabel =
        btn.getAttribute(
          'data-added-label'
        ) || 'Agregado ✓';

      var errorLabel =
        'No se pudo agregar';


      btn.classList.add(
        'is-loading'
      );

      btn.classList.remove(
        'is-added',
        'is-error'
      );


      fetch('/cart/add.js', {

        method: 'POST',

        headers: {
          'Content-Type':
            'application/json',

          Accept:
            'application/json'
        },

        body: JSON.stringify({

          items: [
            {
              id:
                parseInt(
                  variantId,
                  10
                ),

              quantity: 1
            }
          ]

        })

      })

        .then(function (response) {

          if (!response.ok) {

            return response
              .json()
              .then(
                function (data) {

                  throw new Error(
                    data.description ||
                    'cart-error'
                  );

                }
              );

          }


          return response.json();

        })

        .then(function () {

          btn.classList.remove(
            'is-loading'
          );

          btn.classList.add(
            'is-added'
          );


          if (labelEl) {

            labelEl.textContent =
              addedLabel;

          }


          document.dispatchEvent(
            new CustomEvent(
              'tranqui:cart:updated'
            )
          );


          window.setTimeout(
            function () {

              btn.classList.remove(
                'is-added'
              );


              if (labelEl) {

                labelEl.textContent =
                  addLabel;

              }

            },

            2200

          );

        })

        .catch(function () {

          btn.classList.remove(
            'is-loading'
          );

          btn.classList.add(
            'is-error'
          );


          if (labelEl) {

            labelEl.textContent =
              errorLabel;

          }


          window.setTimeout(
            function () {

              btn.classList.remove(
                'is-error'
              );


              if (labelEl) {

                labelEl.textContent =
                  addLabel;

              }

            },

            2200

          );

        });

    }

  );



  document.addEventListener(
    'shopify:block:select',

    function (event) {

      var step =

        event.target.matches &&
        event.target.matches(
          '[data-tk-step]'
        )

          ? event.target

          : (
              event.target.querySelector

                ? event.target
                    .querySelector(
                      '[data-tk-step]'
                    )

                : null
            );


      if (!step) return;


      step.classList.add(
        'is-visible'
      );


      step.scrollIntoView({
        behavior:
          'smooth',

        block:
          'center'
      });

    }

  );

})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pasoslimpiapatas"] && !Shopify.designMode) return;
  try {
    

(function () {

  function clamp(value, min, max) {
    return Math.min(
      Math.max(value, min),
      max
    );
  }


  function initRoot(root) {

    if (!root) return;

    if (
      root.dataset
        .tranquiCleanFlowReady
      === 'true'
    ) return;


    root.dataset
      .tranquiCleanFlowReady =
      'true';


    var timeline =
      root.querySelector(
        '[data-tcf-timeline]'
      );


    if (!timeline) return;


    var steps =
      Array.from(
        root.querySelectorAll(
          '[data-tcf-step]'
        )
      );


    var reveals =
      Array.from(
        root.querySelectorAll(
          '[data-tcf-reveal]'
        )
      );


    var observer =
      null;


    var ticking =
      false;


    function showAll() {

      steps
        .concat(reveals)
        .forEach(
          function (item) {

            item.classList.add(
              'is-visible'
            );

          }
        );

    }


    if (
      'IntersectionObserver'
      in window
    ) {

      observer =
        new IntersectionObserver(

          function (entries) {

            entries.forEach(
              function (entry) {

                if (
                  !entry.isIntersecting
                ) return;


                entry.target
                  .classList
                  .add(
                    'is-visible'
                  );


                observer.unobserve(
                  entry.target
                );

              }
            );

          },

          {
            threshold: 0.16,
            rootMargin:
              '0px 0px -8% 0px'
          }

        );


      steps.forEach(
        function (step) {

          observer.observe(
            step
          );

        }
      );


      reveals.forEach(
        function (item) {

          observer.observe(
            item
          );

        }
      );

    } else {

      showAll();

    }


    function updateProgress() {

      ticking = false;


      var rect =
        timeline
          .getBoundingClientRect();


      var viewportHeight =
        window.innerHeight ||
        document.documentElement
          .clientHeight;


      var start =
        viewportHeight * 0.76;


      var end =
        viewportHeight * 0.28;


      var distance =
        rect.height +
        start -
        end;


      var travelled =
        start -
        rect.top;


      var progress =
        clamp(
          travelled /
          Math.max(distance, 1),
          0,
          1
        );


      root.style.setProperty(
        '--tcf-progress',
        progress.toFixed(4)
      );

    }


    function requestUpdate() {

      if (ticking) return;


      ticking = true;


      window.requestAnimationFrame(
        updateProgress
      );

    }


    window.addEventListener(
      'scroll',
      requestUpdate,
      {
        passive: true
      }
    );


    window.addEventListener(
      'resize',
      requestUpdate,
      {
        passive: true
      }
    );


    updateProgress();

  }


  function initAll() {

    document
      .querySelectorAll(
        '[data-tranqui-clean-flow]'
      )
      .forEach(
        initRoot
      );

  }


  if (
    document.readyState
    === 'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      initAll
    );

  } else {

    initAll();

  }


  document.addEventListener(
    'shopify:section:load',
    function (event) {

      var root =
        event.target
          .querySelector(
            '[data-tranqui-clean-flow]'
          );


      if (root) {
        initRoot(root);
      }

    }
  );


  document.addEventListener(
    'shopify:block:select',
    function (event) {

      var step = null;


      if (
        event.target.matches &&
        event.target.matches(
          '[data-tcf-step]'
        )
      ) {

        step = event.target;

      } else if (
        event.target.querySelector
      ) {

        step =
          event.target
            .querySelector(
              '[data-tcf-step]'
            );

      }


      if (!step) return;


      step.classList.add(
        'is-visible'
      );


      step.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });

    }
  );

})();


  } catch(e) { console.error(e); }
})();
})();
